import * as yup from 'yup';

export const tournamentSchema = yup.object({
  name: yup.string().required('Nombre es requerido'),
  companyId: yup.number().nullable().required('Organizador es requerido'),
  startDate: yup
    .date()
    .nullable()
    .transform((value, originalValue) => {
      if (originalValue === null || originalValue === '' || originalValue === undefined) return null;
      return originalValue instanceof Date ? originalValue : new Date(originalValue);
    })
    .typeError('Fecha de inicio no es válida')
    .required('Fecha de inicio es requerida'),

  endDate: yup
  .date()
  .nullable()
  .transform((value, originalValue) => {
    if (originalValue === null || originalValue === '' || originalValue === undefined) return null;
    return originalValue instanceof Date ? originalValue : new Date(originalValue);
  })
  .typeError('La fecha de fin no es válida')
  .required('La fecha de fin es requerida')
  .when('startDate', (startDate: any, schema) => {
    if (!startDate || isNaN(new Date(startDate).getTime())) {
      return schema;
    }
    return schema.min(startDate, 'La fecha de fin debe ser posterior a la fecha de inicio');
  }),
  fileCover: yup
  .mixed()
  .nullable()
  .when('urlCoverPhoto', {
    is: (urlCoverPhoto:any) => !urlCoverPhoto, // if urlCoverPhoto is empty
    then: (schema) => schema
      .required('Imagen es requerida')
      .test('fileSize', 'La imagen no debe pesar más de 2MB', (value: any) => {
        if (!value) return false;
        return value.size <= 2 * 1024 * 1024; // 2MB max
      })
      .test('fileType', 'Formato del archivo no es válido', (value: any) => {
        if (!value) return false;
        const supportedFormats = ['image/jpg', 'image/jpeg', 'image/png'];
        return supportedFormats.includes(value.type);
      }),
    otherwise: (schema) => schema.notRequired(),
  }),
  title: yup.string().required('Título es requerido'),
  description: yup.string().required('Descripción es requerida')
});